<div id="user-maintenance" class="container-fluid content-box">
    <h2>Users Settings</h2>
    <div class="row">
        <div class="col-2">
            <div class="section">
                <div class="section-header">
                    Users
                </div>
                <div class="section-body user-list-box">
                    <div *ngIf="loading" class="loading"><i class="fas fa-cog fa-spin"></i>Loading, please wait...</div>
                    <ul class="user-list" *ngIf="!loading">
                        <li *ngFor="let user of users"><a role="button" (click)="userDetailsNeeded(user)" [ngClass]="{'selected': user.isSelected}">{{user.lastName | titlecase}}, {{user.firstName | titlecase}}</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col" *ngIf="user && user.id">
            <div class="row">
                <div class="col">
                    <div class="section">
                        <div class="section-header">
                            User Info
                        </div>
                        <div class="section-body">
                            <form (ngSubmit)="onPersonalSubmit()">
                                <div class="form-group row">
                                    <label for="firstName" class="col-sm-2 col-form-label">First Name</label>
                                    <div class="col">
                                        <input name="firstName" type="text" [(ngModel)]="user.firstName" class="form-control form-control-sm" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="lastName" class="col-sm-2 col-form-label">Last Name</label>
                                    <div class="col">
                                        <input name="lastName" type="text" [(ngModel)]="user.lastName" class="form-control form-control-sm" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="email" class="col-sm-2 col-form-label">Email</label>
                                    <div class="col">
                                        <input name="email" type="email" [(ngModel)]="user.email" class="form-control form-control-sm" />
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="phone" class="col-sm-2 col-form-label">Phone #</label>
                                    <div class="col">
                                        <input name="phone" type="text" [(ngModel)]="user.phone" class="form-control form-control-sm" />
                                    </div>
                                </div>

                                <div class="form-group float-right" *ngIf="false">
                                    <button [disabled]="loading" type="submit" class="btn btn-light">
                                            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                                            <fa-icon *ngIf="user.ok" [icon]="['fas', 'check']" style="color: #080;"></fa-icon>
                                            <fa-icon *ngIf="user.error" [icon]="['fas', 'times']" style="color: #c00;"></fa-icon>
                                              <span>Save</span>
                                            </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="section">
                        <div class="section-header">
                            Account
                            <div class="header-buttons">
                                <label style="float: right;">
                                    Approved
                                    <input type="checkbox" [(ngModel)]="user.account.isApproved" (change)="setApproved()" style="margin-left: 0.25em;"/>
                                </label>
                            </div>
                        </div>
                        <div class="section-body">
                            <div class="form-group row">
                                <label for="accountNumber" class="col-sm-2 col-form-label">OHI Account #</label>
                                <div class="col">
                                    <input name="accountNumber" type="text" [(ngModel)]="user.accountNumber" class="form-control form-control-sm" />
                                </div>
                            </div>
                            <div class="form-group row" style="margin-bottom: 0;">
                                <label for="businessName" class="col-sm-2 col-form-label">Business Name</label>
                                <div class="col">
                                    <input name="businessName" type="text" [(ngModel)]="user.businessName" class="form-control form-control-sm" />
                                </div>
                            </div>
                            <div class="sub-section">
                                <div class="sub-section-header">
                                    Assigned Roles
                                </div>
                                <div class="sub-section-body">
                                    <mat-selection-list #list [(ngModel)]="user.roles" [compareWith]="isRoleSelected" (selectionChange)="updateRole($event)">
                                        <mat-list-option *ngFor="let role of roles" [value]="role">{{role.name}}</mat-list-option>
                                    </mat-selection-list>
                                </div>
                            </div>
                            <div class="sub-section">
                                <div class="sub-section-header">
                                    Practice Accelerator Services
                                </div>
                                <div class="sub-section-body">
                                    <kendo-treeview kendoTreeViewExpandable [nodes]="paServices" textField="title" [children]="fetchChildren" [hasChildren]="hasChildren" [kendoTreeViewCheckable]="checkableSettings" kendoTreeViewExpandable kendoTreeViewHierarchyBinding childrenField="children"
                                        [isChecked]="isItemChecked" (checkedChange)="handleChecking($event)">
                                    </kendo-treeview>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>